var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "003-instagram",
    clipPath: "url(#clip0_1247_6260)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75045 2.99388C-0.70722 6.58538 0.000446692 10.4005 0.000446692 21.9909C0.000446692 31.6159 -1.67889 41.2647 7.11011 43.5362C9.85461 44.242 34.1719 44.242 36.9128 43.5325C40.5721 42.5884 43.5494 39.6202 43.9564 34.4447C44.0133 33.7224 44.0133 10.2722 43.9546 9.53521C43.5219 4.02238 40.1284 0.845211 35.6569 0.201711C34.6321 0.053211 34.4268 0.00921103 29.1688 4.43608e-05C10.5183 0.00921103 6.42995 -0.821289 2.75045 2.99388Z",
    fill: "url(#paint0_linear_1247_6260)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.9966 5.75481C15.3398 5.75481 9.01848 5.16265 6.60398 11.3593C5.60664 13.9186 5.75148 17.2425 5.75148 22.0018C5.75148 26.1782 5.61764 30.1033 6.60398 32.6425C9.01298 38.8428 15.3856 38.2488 21.993 38.2488C28.3675 38.2488 34.94 38.9125 37.3838 32.6425C38.383 30.0575 38.2363 26.7832 38.2363 22.0018C38.2363 15.6548 38.5865 11.5573 35.5083 8.48098C32.3916 5.36431 28.1768 5.75481 21.9893 5.75481H21.9966ZM20.541 8.68265C34.4266 8.66065 36.194 7.11698 35.2186 28.5615C34.8721 36.146 29.0971 35.3137 21.9985 35.3137C9.05514 35.3137 8.68298 34.9433 8.68298 21.9945C8.68298 8.89532 9.70964 8.68998 20.541 8.67898V8.68265ZM30.6683 11.3795C29.5921 11.3795 28.7195 12.2521 28.7195 13.3283C28.7195 14.4045 29.5921 15.2771 30.6683 15.2771C31.7445 15.2771 32.6171 14.4045 32.6171 13.3283C32.6171 12.2521 31.7445 11.3795 30.6683 11.3795ZM21.9966 13.6583C17.3895 13.6583 13.655 17.3947 13.655 22.0018C13.655 26.609 17.3895 30.3435 21.9966 30.3435C26.6038 30.3435 30.3365 26.609 30.3365 22.0018C30.3365 17.3947 26.6038 13.6583 21.9966 13.6583ZM21.9966 16.5861C29.1558 16.5861 29.165 27.4175 21.9966 27.4175C14.8393 27.4175 14.8283 16.5861 21.9966 16.5861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1247_6260",
    x1: 2.83482,
    y1: 41.1897,
    x2: 43.7282,
    y2: 5.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_6260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColor);
export default __webpack_public_path__ + "static/media/instagram-color.84123e3e3abea4556f33c54026a4c5d9.svg";
export { ForwardRef as ReactComponent };